<template>
  <div v-loading="loading" class="nx-page nx-report-page kanban-daily-plan-tracking">

    <el-form :inline="true" class="kb-filter-bar" size="small" @submit.native.prevent>
      <el-form-item label="作业日期">
        <el-date-picker
          v-model="queryDate"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          style="width: 150px"
        />
      </el-form-item>
      <el-form-item label="业务类型">
        <el-select v-model="filters.businessType" clearable placeholder="全部" style="width: 130px">
          <el-option label="铁运入库" :value="1" />
          <el-option label="汽运出库" :value="2" />
          <el-option label="汽运入库" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item label="跟踪状态">
        <el-select v-model="filters.trackStatus" clearable placeholder="全部" style="width: 140px">
          <el-option label="待审核" value="audit_pending" />
          <el-option label="未开始" value="not_started" />
          <el-option label="进行中" value="in_progress" />
          <el-option label="已完成" value="done" />
          <el-option label="已超期未完成" value="late" />
        </el-select>
      </el-form-item>
      <el-form-item label="审核">
        <el-select v-model="filters.auditFlag" clearable placeholder="全部" style="width: 110px">
          <el-option label="待审核" :value="0" />
          <el-option label="已审核" :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loadData">查询</el-button>
      </el-form-item>
    </el-form>

    <div class="kb-kpi-row">
      <div class="kb-kpi-card">
        <div class="kb-kpi-label">当日日计划条数</div>
        <div class="kb-kpi-value">{{ kpi.dayPlanCount }}</div>
      </div>
      <div class="kb-kpi-card">
        <div class="kb-kpi-label">吨位加权平均完成率</div>
        <div class="kb-kpi-value">{{ fmtPct(kpi.weightedTonRatePercent) }}</div>
      </div>
      <div class="kb-kpi-card">
        <div class="kb-kpi-label">待审核 / 未开始</div>
        <div class="kb-kpi-value is-warn">{{ kpi.auditPendingCount }} / {{ kpi.notStartedCount }}</div>
      </div>
      <div class="kb-kpi-card">
        <div class="kb-kpi-label">进行中</div>
        <div class="kb-kpi-value is-warn">{{ kpi.inProgressCount }}</div>
      </div>
      <div class="kb-kpi-card">
        <div class="kb-kpi-label">已完成</div>
        <div class="kb-kpi-value">{{ kpi.doneCount }}</div>
      </div>
      <div class="kb-kpi-card">
        <div class="kb-kpi-label">超期未完成</div>
        <div class="kb-kpi-value is-danger">{{ kpi.lateCount }}</div>
      </div>
    </div>

    <div class="kb-charts-row">
      <div class="kb-chart-card">
        <div class="kb-chart-head">分业务类型 · 计划吨 vs 已执行吨</div>
        <div ref="chartBar" class="kb-chart-box" />
      </div>
      <div class="kb-chart-card">
        <div class="kb-chart-head">完成状态分布</div>
        <div ref="chartPie" class="kb-chart-box" />
      </div>
    </div>

    <div class="kb-section">
      <div class="kb-section-head">日计划明细</div>
      <el-table :data="planRows" border stripe size="small" max-height="480" style="width: 100%">
        <el-table-column prop="planNo" label="计划编号" min-width="130" show-overflow-tooltip />
        <el-table-column prop="planName" label="计划名称" min-width="120" show-overflow-tooltip />
        <el-table-column prop="businessTypeLabel" label="业务类型" width="100" />
        <el-table-column prop="custName" label="货主名称" min-width="100" show-overflow-tooltip />
        <el-table-column prop="cargoName" label="煤种名称" min-width="100" show-overflow-tooltip />
        <el-table-column label="计划区间" min-width="118">
          <template slot-scope="{ row }">
            <span style="font-size: 12px; white-space: nowrap">{{ row.intervalStartStr }}<br />~ {{ row.intervalEndStr }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="planTotalWeight" label="计划数量（吨）" width="118" align="right" :formatter="fmtTonCol" />
        <el-table-column prop="planExecuteWeight" label="计划执行进度（吨）" width="138" align="right" :formatter="fmtTonCol" />
        <el-table-column label="执行率" min-width="130">
          <template slot-scope="{ row }">
            <span>{{ row.executeRatePercent != null ? row.executeRatePercent + '%' : '—' }}</span>
            <div v-if="row.executeRatePercent != null" class="pct-bar">
              <i :style="{ width: barW(row.executeRatePercent) }" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="车数 计/完/执行中" width="130" align="center">
          <template slot-scope="{ row }">
            {{ row.planTruckCount != null ? row.planTruckCount : 0 }} /
            {{ row.completeTruckCount != null ? row.completeTruckCount : 0 }} /
            {{ row.executingTruckCount != null ? row.executingTruckCount : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="auditLabel" label="审核" width="88" />
        <el-table-column label="跟踪状态" width="118">
          <template slot-scope="{ row }">
            <el-tag :type="tagTypeTrack(row.trackStatusKey)" size="small">{{ row.trackStatusLabel }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import * as echarts from 'echarts'
import NxReportHeader from '@/components/nx/report/NxReportHeader.vue'
import { fetchDailyPlanTracking } from './api'

export default {
  name: 'KanbanDailyPlanTracking',
  components: { NxReportHeader },
  data() {
    return {
      loading: false,
      queryDate: moment().format('YYYY-MM-DD'),
      filters: {
        businessType: null,
        trackStatus: null,
        auditFlag: null
      },
      result: null,
      chartInstances: []
    }
  },
  computed: {
    kpi() {
      const k = this.result && this.result.kpi
      return (
        k || {
          dayPlanCount: 0,
          weightedTonRatePercent: null,
          auditPendingCount: 0,
          notStartedCount: 0,
          inProgressCount: 0,
          doneCount: 0,
          lateCount: 0
        }
      )
    },
    planRows() {
      return (this.result && this.result.planRows) || []
    }
  },
  mounted() {
    this.loadData()
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    this.disposeCharts()
  },
  methods: {
    barW(pct) {
      const n = Math.min(100, Math.max(0, Number(pct) || 0))
      return n + '%'
    },
    fmtPct(v) {
      if (v == null || v === '') return '—'
      const n = Number(v)
      if (Number.isNaN(n)) return '—'
      return n.toFixed(1) + '%'
    },
    fmtTonCol(row, col, val) {
      if (val == null || val === '') return '—'
      const n = Number(val)
      if (Number.isNaN(n)) return '—'
      return n.toLocaleString('zh-CN', { maximumFractionDigits: 2 })
    },
    tagTypeTrack(key) {
      if (key === 'late') return 'danger'
      if (key === 'audit_pending') return 'warning'
      if (key === 'in_progress') return 'primary'
      if (key === 'done') return 'success'
      return 'info'
    },
    disposeCharts() {
      this.chartInstances.forEach((c) => c && c.dispose())
      this.chartInstances = []
    },
    onResize() {
      this.chartInstances.forEach((c) => c && c.resize())
    },
    async loadData() {
      if (!this.queryDate) {
        this.queryDate = moment().format('YYYY-MM-DD')
      }
      this.loading = true
      try {
        const body = {
          queryDate: this.queryDate,
          businessType: this.filters.businessType,
          auditFlag: this.filters.auditFlag,
          trackStatus: this.filters.trackStatus || undefined
        }
        const data = await fetchDailyPlanTracking(body)
        this.result = data
        this.$nextTick(() => this.renderCharts())
      } catch (e) {
        this.$message.error((e && e.message) || '加载失败')
      } finally {
        this.loading = false
      }
    },
    renderCharts() {
      this.disposeCharts()
      const rows = this.planRows
      const btNames = ['铁运入库', '汽运出库', '汽运入库']
      const planByBt = [0, 0, 0]
      const execByBt = [0, 0, 0]
      rows.forEach((r) => {
        const i = (r.businessType || 0) - 1
        if (i >= 0 && i < 3) {
          planByBt[i] += Number(r.planTotalWeight) || 0
          execByBt[i] += Number(r.planExecuteWeight) || 0
        }
      })
      const stMap = {
        audit_pending: 0,
        not_started: 0,
        in_progress: 0,
        done: 0,
        late: 0
      }
      rows.forEach((r) => {
        const k = r.trackStatusKey
        if (stMap[k] !== undefined) stMap[k]++
      })
      const pieData = [
        { name: '待审核', value: stMap.audit_pending },
        { name: '未开始', value: stMap.not_started },
        { name: '进行中', value: stMap.in_progress },
        { name: '已完成', value: stMap.done },
        { name: '超期未完成', value: stMap.late }
      ].filter((x) => x.value > 0)

      const barEl = this.$refs.chartBar
      const pieEl = this.$refs.chartPie
      if (!barEl || !pieEl) return

      const i1 = echarts.getInstanceByDom(barEl)
      if (i1) i1.dispose()
      const i2 = echarts.getInstanceByDom(pieEl)
      if (i2) i2.dispose()

      const c1 = echarts.init(barEl)
      c1.setOption({
        tooltip: { trigger: 'axis' },
        legend: { data: ['计划吨', '已执行吨'], bottom: 0 },
        grid: { left: 48, right: 16, top: 24, bottom: 40 },
        xAxis: { type: 'category', data: btNames },
        yAxis: { type: 'value', name: '吨' },
        series: [
          { name: '计划吨', type: 'bar', data: planByBt, itemStyle: { color: '#94a3b8', borderRadius: [4, 4, 0, 0] } },
          { name: '已执行吨', type: 'bar', data: execByBt, itemStyle: { color: '#0d9488', borderRadius: [4, 4, 0, 0] } }
        ]
      })
      this.chartInstances.push(c1)

      const c2 = echarts.init(pieEl)
      c2.setOption({
        tooltip: { trigger: 'item' },
        legend: { bottom: 0, textStyle: { fontSize: 11 } },
        series: [
          {
            type: 'pie',
            radius: ['40%', '68%'],
            data: pieData.length ? pieData : [{ name: '无数据', value: 1, itemStyle: { color: '#e2e8f0' } }],
            label: { formatter: '{b}\n{c}条', fontSize: 11 }
          }
        ]
      })
      this.chartInstances.push(c2)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';

.kb-header-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
</style>
